// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { locationFinderStyles } from "@eisinc/Overrides/Widgets/LocationFinder/LocationFinder";
import { xScreen } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

locationFinderStyles.container = {
    gap: 30,
    css: css`
        margin-bottom: 25px;
    `,
};

locationFinderStyles.leftColumnGridItem = {
    width: [12, 12, 12, 12, 12],
    css: css`
        ${xScreen("lte", "md")} {
            order: 2;
        }
    `,
};

locationFinderStyles.rightColumnGridItem = {
    width: [12, 12, 12, 12, 12],
    css: css`
        ${xScreen("lte", "md")} {
            order: 1;
        }
    `,
};
